import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Card, Alert, Typography, Space } from 'antd';
import { UserOutlined, MailOutlined } from '@ant-design/icons';

import MainLayout from '../layouts/main'
import { connect } from 'react-redux';
import { requestServerGet, selectBranch, selectBrand, requestServerPost, selectPage, logout } from '../../actions';
import { set } from 'lodash';
import Constants from '../../data/constants';

const { Title, Text } = Typography;

const GuestActivationView = (props) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(null); // { type: 'success' | 'error', message: string }
    const [isActivated, setIsActivated] = useState(false);
    const [guestName, setGuestName] = useState("GuestUser");

    const { logout } = props;

    const onFinish = async (values) => {

        if (isActivated) {
            logout();
        }

        setLoading(true);
        setStatus(null);
        const { email } = values;


        const { requestServerPost, usertoken } = props;
        const params = new FormData();

        params.append("username", guestName)
        params.append("email", email)

        requestServerPost("verify_email", params, {}, (response) => {
            console.log("active guest response " + JSON.stringify(response))

            setLoading(false);
            setIsActivated(true);

            setStatus({
                type: 'success',
                message: `A verification link has been sent to your email. Please check your email to verify your account.`
            });
            console.log('Activation successful:', values);
            // setTimeout(() => {

            //     logout();
            //     // Redirect or further actions can be placed here
            // }, 5000);
        }, usertoken, {}, () => {
            setLoading(false)
        });



    };

    useEffect(() => {
        // Any initialization if needed
        const { userdata } = props;

        console.log("GuestActivationView userdata => " + JSON.stringify(userdata))
        if (userdata && userdata.user) {
            setGuestName(userdata.user.username || "GuestUser");
        }

    }, []);
    return (

        <MainLayout id={Constants.GUEST_ACTIVATION_PAGE} showSideMenu={false} showSearchBar={false} showTitleBar={false} style={{ padding: 0 }}>
            <div style={styles.container}>
                <Card style={styles.card} hoverable>
                    <div style={{ textAlign: 'center', marginBottom: 24 }}>
                        <Title level={3}>Activate Account</Title>
                        <Text type="secondary">Convert your guest session to a permanent account.</Text>
                    </div>

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={false}
                    >
                        {/* 1. Guest Username (Read-Only) */}
                        <Form.Item label="Current Guest Username">
                            <Input
                                prefix={<UserOutlined />}
                                value={guestName}
                                disabled
                            />
                        </Form.Item>

                        {/* 2. Email Input with Validation */}
                        <Form.Item
                            label="New Email Address"
                            name="email"
                            rules={[
                                { required: true, message: 'Please input your email!' },
                                { type: 'email', message: 'The input is not a valid E-mail!' }
                            ]}
                        >
                            <Input
                                prefix={<MailOutlined />}
                                placeholder="user@example.com"
                                size="large"
                            />
                        </Form.Item>

                        {/* Feedback Message */}
                        {status && (
                            <Form.Item>
                                <Alert
                                    message={status.message}
                                    type={status.type}
                                    showIcon
                                    closable
                                />
                            </Form.Item>
                        )}

                        {/* Submit Button */}
                        <Form.Item style={{ marginBottom: 0, marginTop: 16 }}>

                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                                block
                                size="large"
                            >
                                {isActivated ? "Back to Login" : "Bind Email and Activate"}
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
        </MainLayout>
    );
};

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f2f5',
        padding: '20px'
    },
    card: {
        width: '100%',
        maxWidth: '420px',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.05)'
    }
};


const mapStateToProps = (state) => ({
    userdata: state.userdata,
    usertoken: state.usertoken,
    globalSearch: state.globalSearch,
    selectedBrandData: state.selectedBrandData,
    selectedBranchData: state.selectedBranchData
});

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectBrand, selectBranch, selectPage, logout })(GuestActivationView);
